// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2SB0H","header":"ReportDetails_header__YsqDc","title":"ReportDetails_title__2uiSM","left":"ReportDetails_left__3nGr6"};